<template>
  <div>
    <FrameHeader/>

    <div class="boxed mt-4">
      <div class="ui-tabset tac">
        <span 
          v-for="item of home_tabs"
          :key="item.id"
          @click="on_tab = item.id"
          :class="['tab size-big',{'on': on_tab == item.id}]"
        >
          {{lg('',item.name)}}
        </span>
      </div>
      <hr>

      <div class="mt-4 pt-2 d-flex">
        <CpBtnSortList 
          class="ml-auto"
          v-model="on_filter"
        />
      </div>
    </div>

    <div class="boxed home-main-box pb-4">

      <div class="home-filter">
        <div class="mt-4 pt-2">
          <filterSet :form="filter_set"/>
        </div>
      </div>

      <div class="home-card-list w-100">
        
        <div v-if="status_ajaxing_list" class="text-dark tac p-5">Loading...</div>

        <div v-else class="list-main-prod pb-5">
          <div class="item mb-4" v-for="(item,index) of list_on_show" :key="index">
            <CpCardProd :data="item"/>
          </div>
        </div>
      </div>

    </div>

    <FrameFooter/>
  </div>
</template>

<script>
// import list_main_asset from '@/data/list_main_asset.js'
import home_tabs from './home_tabs.js'
import filterSet from './filter_set.vue'

import data_filter_set from './data_filter_set.js'

let data_filter_set_keys = data_filter_set.map(item => item.id)
let init_filter_keys = {}
data_filter_set_keys.forEach(function(item){
  init_filter_keys[item] = ''
})

export default {
  name: 'pageHome',
  components: {
    filterSet,
  },
  props: [],
  data() {
    return {
      on_tab: 'all',
      on_filter: '',
      home_tabs: home_tabs,

      status_ajaxing_list: false,
      list_on_show: [],


      filter_set: init_filter_keys,
    }
  },
  computed: {},
  watch: {
    on_tab(){
      this.getListOnShow()
    },
    on_filter(){
      this.getListOnShow()
    },
    filter_set: {
      deep: true,
      handler(){
        this.getListOnShow()
      },
    },
  },
  methods: {
    
    async getListOnShow(){
      let v = this

      let res = await v.api('list_asset',{
        'category':v.on_tab,
        'filter':v.on_filter,
        'filter_more':v.filter_set,
      },{
        vue: v,
        key_data: 'list_on_show',
        key_ajaxing: 'status_ajaxing_list',
      })
    },
    run(){
      let v = this
      if(!v.on_tab){
        v.on_tab = v.home_tabs.length?v.home_tabs[0].id:''
      }

      v.getListOnShow()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .home-main-box{

    @media(min-width: 788px){
      display: flex;

      .home-filter{
        width: 300px;
      }
      .home-cards-list{
        width: 100%;
      }
    }
  }
</style>